import { render, staticRenderFns } from "./CategoryCognize.vue?vue&type=template&id=f10dac16&scoped=true"
import script from "./CategoryCognize.vue?vue&type=script&lang=js"
export * from "./CategoryCognize.vue?vue&type=script&lang=js"
import style0 from "./CategoryCognize.vue?vue&type=style&index=0&id=f10dac16&prod&lang=css"
import style1 from "./CategoryCognize.vue?vue&type=style&index=1&id=f10dac16&prod&scoped=true&lang=css"
import style2 from "../../constant/css/detail.css?vue&type=style&index=2&id=f10dac16&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10dac16",
  null
  
)

export default component.exports